import { cva } from "class-variance-authority";

export const containerStyles = cva([
  "container mx-auto max-w-[1512px] p-4",
  "lg:p-8",
]);
